const formatPriceToPounds = (price, useMonthly = false)=>`£${price.toLocaleString()}${useMonthly ? " p/m" : ""}`;
const getFormattedFromPrice = (priceSelection = -1, useMonthly = false)=>{
    if (priceSelection === -1) return "";
    return `From ${formatPriceToPounds(priceSelection, useMonthly)}`;
};
const getFormattedToPrice = (priceSelection = -1, useMonthly = false)=>{
    if (priceSelection === -1) return "";
    return `Up to ${formatPriceToPounds(priceSelection, useMonthly)}`;
};
export const getFormattedPriceRange = (fromPriceSelection = -1, toPriceSelection = -1, useMonthly = false)=>{
    if (fromPriceSelection === -1 && toPriceSelection === -1) return "";
    const fromPrice = getFormattedFromPrice(fromPriceSelection, useMonthly);
    let toPrice = getFormattedToPrice(toPriceSelection, useMonthly);
    if (fromPrice) {
        toPrice = ` ${toPrice.replace("Up ", "").toLowerCase()}`;
    }
    return `${fromPrice}${toPrice}`.trim();
};
